import { Alert, ConfigProvider, DatePicker, Form, Input, message, Modal } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import container from "@/lib/di/container";
import React from "react";
import { WaterIndexModel } from "@/core/models/water-index.model";
import { WaterIndexRepo } from "@/core/repos/tables/water-index.repo";
import { dayjsPipe } from "@/core/pipes/dayjs.pipe";
import { formatDatePipe } from "@/core/pipes/format-date.pipe";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { usePermissionStore } from "@/core/stores/permission.store";
import { Image } from 'antd';
import { SaveButton } from "@/app/home/components/table/SaveButton";
import { DEF_DATE_FORMAT } from "@/app/home/utils/global.utils";

const waterIndexRepo = container.get(WaterIndexRepo);

interface DetailModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    data: WaterIndexModel,
}

const INPUT_WIDTH = 450;

export const DetailModal: React.FC<DetailModalProps> = ({isModalOpen, setIsModalOpen, data}) => {
    const permissionStore = usePermissionStore();
    const [form] = Form.useForm<WaterIndexModel>();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [messageApi, contextHolder] = message.useMessage();    
    // Attach hooks to handle data changes
    const handleDataChange = async () => {
        // Loại bỏ previousIndexes khi set vào form vì form không cần field này
        const { previousIndexes, ...formData } = data;
        form.setFieldsValue(formData);
        if (data.id && data.id.length > 0) {
            setIsEdit(true);
        } else {
            setIsEdit(false);
        }
    }
    useEffect(() => {
        handleDataChange();
    }, [data])

    // Initialize select options data
    const init = async () => {
        // await populateTollAreas();
    }
    // componentDidMount equivalent, run exclusively on client-side
    useEffect(() => {init()}, []);


    const handleSave = async () => {
        try {
            setLoading(true);
            const formData = await form.validateFields();
            if (isEdit) {
                formData.id = data.id;
                const result = await waterIndexRepo.updateIndex({...formData, waterUser: undefined, waterUserId: formData.waterUser?.id??""});
                setIsModalOpen(false);
                if (result?.code=="00") {
                    messageApi.success({
                        content: "Đã cập nhật chỉ số"
                    })
                } else {
                    messageApi.error({
                        content: result?.errorMessage??"Cập nhật chỉ số thất bại"
                    })
                }
            } else {
                const result = await waterIndexRepo.create({...data, ...formData});
                setIsModalOpen(false);
                if (result) {
                    messageApi.success({
                        content: "Thêm chỉ số mới thành công"
                    })
                } else {
                    messageApi.error({
                        content: "Thêm chỉ số mới thất bại"
                    })
                }
            }
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    };
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    return (
        <ConfigProvider theme={MODAL_THEME}>
            {contextHolder}
            <Modal open={isModalOpen} onCancel={handleCancel} width={975} style={{ top: 20 }}
                styles={{
                    mask: {
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'var(--primary-mask)'
                    }
                }}
                footer={[
                    <div key={1} className="w-full flex flex-row justify-end px-1.5">
                        <SaveButton isEdit={isEdit} loading={loading} onClick={handleSave}/>
                    </div>,
                ]}
            >
                <div className="flex flex-row w-full items-start justify-start select-none">
                    <p className="ml-2 text-2xl font-bold text-primary">THÔNG TIN CHI TIẾT</p>
                </div>
                {data.isMeterChanged && (
                    <Alert
                        type="info"
                        showIcon
                        message="Kỳ này có thay đồng hồ giữa kỳ"
                        description={`Đồng hồ mới đã được lắp trong kỳ. Chỉ số đầu của đồng hồ mới = ${data.newMeterHeadIndex ?? "?"}, đồng hồ cũ tháo tại ${data.oldMeterRemovedIndex ?? "?"}. Lượng nước tiêu thụ được tính gộp 2 đoạn — hệ thống đã tính sẵn, bạn chỉ cần nhập chỉ số cuối của đồng hồ mới.`}
                        style={{ margin: "12px 8px" }}
                    />
                )}
                <div className="flex flex-row justify-center mt-6">
                    <Form<WaterIndexModel>
                        name="basic"
                        className="flex flex-col items-end"
                        form={form}
                        layout="vertical"
                        disabled={isEdit&&!permissionStore.page.edit}
                    >
                        <div className="flex">
                            <div className="flex flex-col w-1/2 pr-4">
                                <Form.Item<WaterIndexModel>
                                    label="Mã hợp đồng"
                                    name="waterUser"
                                    
                                    getValueProps={(e) => ({value: e.code})}
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Mã đồng hồ"
                                    name="waterUser"
                                    getValueProps={(e) => ({value: e.waterMeterCode})}
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Năm"
                                    name="year"
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Tháng"
                                    name="month"
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Ngày tạo"
                                    name="createdAt"
                                    getValueProps={(i) => ({value: dayjsPipe(i)})}
                                >
                                    <DatePicker format={DEF_DATE_FORMAT} style={{width: INPUT_WIDTH}}></DatePicker>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Ngày cập nhật"
                                    name="updatedAt"
                                    getValueProps={(i) => ({value: formatDatePipe(i)})}
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                            </div>
                            <div className="flex flex-col w-1/2">
                                <Form.Item<WaterIndexModel>
                                    label="Hộ sử dụng nước"
                                    name="waterUser"
                                    getValueProps={(e) => ({value: e.name})}
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Số đo đồng hồ"
                                    name="waterMeterNumber"
                                >
                                    <Input type="number" style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Số đo cũ"
                                    name="oldNumber"
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Số lượng sử dụng"
                                    name="useAmount"
                                    getValueProps={(value) => ({value: value !== null && value !== undefined ? value : "Chưa tính toán"})}
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Chỉ số tối đa đồng hồ"
                                    name="waterMeterMaxIndex"
                                    getValueProps={(value) => ({value: value !== null && value !== undefined ? value : "9999 (mặc định)"})}
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Đồng hồ quay ngược"
                                    name="isReverseRotated"
                                    getValueProps={(value) => ({value: value === true ? "Có" : value === false ? "Không" : "Chưa xác định"})}
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Đã quay hết 1 vòng"
                                    name="isFullRotation"
                                    getValueProps={(value) => ({value: value === true ? "Có" : value === false ? "Không" : "Chưa xác định"})}
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Người tạo"
                                    name="createdBy"
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                                <Form.Item<WaterIndexModel>
                                    label="Người cập nhật"
                                    name="updatedBy"
                                >
                                    <Input disabled style={{width: INPUT_WIDTH}}></Input>
                                </Form.Item>
                            </div>
                        </div>
                        <div className="pr-2">
                            <Form.Item<WaterIndexModel>
                                label="Ghi chú"
                                name="note"
                            >
                                <Input.TextArea rows={3} style={{width: INPUT_WIDTH*2 + 10, resize: "none"}}></Input.TextArea>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
                {data.image&&<div className="mx-1 mb-4 w-full">
                    <p className="mb-2 ml-0.5 text-primary">Ảnh chụp chỉ số nước</p>
                    <div className="mb-5 mx-2 border-t border-dashed border-gray-300"></div>
                    <div className="w-full flex flex-row justify-center items-center">
                        <Image src={data.image} alt="Image" width={350} />
                    </div>
                </div>}
                <div className="mb-5 mx-2 border-t border-dashed border-gray-300"></div>
            </Modal>
        </ConfigProvider>
    )
}